export enum loginTypes {
  FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST",
  FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS",
  FETCH_LOGIN_FAILURE = "FETCH_LOGIN_FAILURE",
}